export const DISCHARGE_SCHEMA = [
  {
    elementConfig: {
      label: "Discharge Type",
      options: [
        { display: "ED", value: "ED" },
        { display: "Urgent Care", value: "Urgent Care" },
        { display: "BH In-Patient", value: "BH In-Patient" },
        { display: "Medical In-Patient", value: "Medical In-Patient" },
        { display: "SUD Inpatient", value: "SUD Inpatient" },
        { display: "N/A", value: "N/A" },
        { display: "Other", value: "Other" },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    name: "discharge_type",
  },
  {
    elementConfig: {
      label: "Discharge Date",
      placeholder: "01/01/2020",
      type: "text",
    },
    elementType: "datepicker",
    name: "discharge_date",
  },
  {
    elementConfig: {
      label: "Additional Discharge Information",
      placeholder: "Type comment...",
      type: "textArea",
    },
    elementType: "textarea",
    name: "additional_discharge_information",
  },
];
